import React from "react";

export default function BulkUpdateGuidance() {
  return (
    <div className="mb-6 w-full px-4 pt-2 sm:px-6">
      <div className="mx-auto flex w-full max-w-6xl rounded-[1.25rem] bg-[#241b31] px-6 py-5 shadow-lg shadow-black/25 md:px-7 md:py-6">
        <div className="grid w-full grid-cols-[1.5rem_1fr] gap-x-4 gap-y-2 text-white md:grid-cols-[1.75rem_1fr]">
          <div className="mt-1 flex h-6 w-6 items-center justify-center rounded-full bg-yellow-1 text-[0.7rem] font-semibold leading-none text-gray-950 md:mt-0.5">
            i
          </div>
          <div className="pt-0.5 text-sm font-semibold uppercase tracking-[0.14em] text-yellow-1">
            Bulk update directions
          </div>
          <div className="col-span-2 flex flex-col gap-1 text-[15px] leading-7 text-white/90 md:flex-row md:items-start md:gap-4">
            <span className="font-medium text-white/95">
              For bulk updates, please:
            </span>
            <ol className="m-0 list-decimal pl-5 md:pl-6">
              <li>Download the current list of numbers using EXPORT below</li>
              <li>Edit, make changes in the spreadsheet</li>
              <li>Upload the edited spreadsheet using IMPORT below</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}
